import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import swal from 'sweetalert2';
import TextareaAutosize from 'vue-textarea-autosize';
import VueLazyload from 'vue-lazyload';
import EventBus from '@/helper/EventBus/eventbus';
import Snotify from 'vue-snotify';
import Multiselect from 'vue-multiselect';
import Lightbox from 'vue-easy-lightbox';
import VueGtm from 'vue-gtm';
import App from './App.vue';
import router from './router';
import store from './store';
import globalMixin from './mixins/globalMixin'; // 全域
import VueQrcode from "@chenfengyuan/vue-qrcode";
Vue.component(VueQrcode.name, VueQrcode);
// Package
Vue.use(BootstrapVue);
Vue.use(TextareaAutosize);
Vue.use(Lightbox);
Vue.use(VueLazyload, {
  preload: 1.5,
  loading: require('@/assets/images/default/loading.gif'),
  error: require('@/assets/images/default/defaultImg404.png'),
  attempt: 2,
  listenEvents: ['scroll']
});
Vue.use(Snotify, {
  toast: {
    timeout: 2500,
    showProgressBar: false,
    pauseOnHover: false,
    animation: {
      enter: 'fadeInRight',
      exit: 'fadeOutRight',
      time: 500
    }
  }
});

Vue.prototype.$companyName = process.env.VUE_APP_COMPANY_NAME;
Vue.prototype.$swal = swal;
Vue.prototype.$EventBus = EventBus;
Vue.use(VueGtm, {
  // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  id: process.env.VUE_APP_GTM_ID,
  // Add url query string when load gtm.js with GTM ID (optional)
  // queryParams: {
  //   gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
  //   gtm_preview:'env-4',
  //   gtm_cookies_win:'x'
  // },
  // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  // enabled: process.env.NODE_ENV === 'development',
  // Whether or not display console logs debugs (optional)
  debug: process.env.VUE_APP_ENV === 'prod',
  // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  loadScript: false,
  // Pass the router instance to automatically sync with router (optional)
  vueRouter: router,
  // If router, you can exclude some routes name (case insensitive) (optional)
  ignoredViews: ['error_404', 'error_422']
});
// Mixin
Vue.mixin(globalMixin);

// Component
Vue.component('multiselect', Multiselect);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
